import { createSelector } from 'reselect'

const getStudent = state => state.student

const getStudentSession = createSelector(
	[ getStudent ],
	student => ({
		device_uid: student.device_uid,
		session_uid: student.session_uid,
		presentation_uid: student.presentation_uid,
		pincode: student.pincode,
		join_token: student.join_token,
		sessionType: student.sessionType,
		headers: student.headers,
	})
)

export default getStudentSession
